var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmaPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_19134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_19134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 26C10.45 26 9.97933 25.8043 9.588 25.413C9.196 25.021 9 24.55 9 24C9 23.45 9.196 22.979 9.588 22.587C9.97933 22.1957 10.45 22 11 22C11.55 22 12.0207 22.1957 12.412 22.587C12.804 22.979 13 23.45 13 24C13 24.55 12.804 25.021 12.412 25.413C12.0207 25.8043 11.55 26 11 26ZM21 26C20.45 26 19.9793 25.8043 19.588 25.413C19.196 25.021 19 24.55 19 24C19 23.45 19.196 22.979 19.588 22.587C19.9793 22.1957 20.45 22 21 22C21.55 22 22.021 22.1957 22.413 22.587C22.8043 22.979 23 23.45 23 24C23 24.55 22.8043 25.021 22.413 25.413C22.021 25.8043 21.55 26 21 26ZM10.15 10L12.55 15H19.55L22.3 10H10.15ZM9.2 8H23.95C24.3333 8 24.625 8.17067 24.825 8.512C25.025 8.854 25.0333 9.2 24.85 9.55L21.3 15.95C21.1167 16.2833 20.8707 16.5417 20.562 16.725C20.254 16.9083 19.9167 17 19.55 17H12.1L11 19H23V21H11C10.25 21 9.68333 20.6707 9.3 20.012C8.91667 19.354 8.9 18.7 9.25 18.05L10.6 15.6L7 8H5V6H8.25L9.2 8Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaPurchase);
export default __webpack_public_path__ + "static/media/PharmaPurchase.71fc756459d0c073ff9140ff792f9cba.svg";
export { ForwardRef as ReactComponent };